import { ActionsFooter, ApprovalDialogButton } from '@components/Forms';
import { LoadingButton } from '@mui/lab';
import React from 'react';

type Props = {
	onSave: () => void;
	onCancel: () => void;
	isSaving: boolean;
	isDirty: boolean;
};

export default ({ onSave, onCancel, isSaving, isDirty }: Props) => (
	<ActionsFooter>
		<LoadingButton
			variant="contained"
			onClick={onSave}
			loading={isSaving}
			disabled={isSaving || !isDirty}
		>
			{intl.tr('styleEditor.save')}
		</LoadingButton>
		<ApprovalDialogButton
			sx={{ marginLeft: 2 }}
			onApprove={onCancel}
			buttonText={intl.tr('styleEditor.cancel')}
			disabled={isSaving || !isDirty}
			title={intl.tr('discard.changes.dialog.title')}
			question={intl.tr('discard.changes.dialog.question')}
			approveText={intl.tr('discard.changes.dialog.approve')}
		/>
	</ActionsFooter>
);
